import { Navigate, RouteObject } from 'react-router-dom';
import AdminCustomerAccessSalesOrdersPage from './admin-customer-access-sales-orders-page/admin-customer-access-sales-orders-page';
import AdminCustomerAccessSetupPage from './admin-customer-access-setup-page/admin-customer-access-setup-page';
import AdminCustomerAccessUserDetailsPage from './admin-customer-access-user-details-page/admin-customer-access-user-details-page';
import AdminDevicesPage, {
  loader as adminDevicesPageLoader,
} from './admin-devices-page/admin-devices-page';
import AdminLicenseKeysPage, {
  loader as adminLicenseKeysPageLoader,
} from './admin-license-keys-page/admin-license-keys-page';
import AdminSalesOrdersPage, {
  loader as adminSalesOrdersPageLoader,
} from './admin-sales-orders-page/admin-sales-orders-page';
import AdminTemporaryAccessManagementPage, {
  loader as adminTemporaryAccessManagementPageLoader,
} from './admin-temporary-access-management-page/admin-temporary-access-management-page';
import AdminTemporaryAccessSalesOrdersPage, {
  loader as adminTemporaryAccessSalesOrdersPage,
} from './admin-temporary-access-sales-orders-page/admin-temporary-access-sales-orders-page';
import AdminTemporaryAccessSetupPage from './admin-temporary-access-setup-page/admin-temporary-access-setup-page';
import AdminTemporaryAccessUserPage from './admin-temporary-access-user-details-page/admin-temporary-access-user-details-page';

export const routes: RouteObject[] = [
  {
    path: 'admin',
    children: [
      {
        loader: adminDevicesPageLoader,
        path: 'devices',
        element: <AdminDevicesPage />,
      },
      {
        loader: adminLicenseKeysPageLoader,
        path: 'license-keys',
        element: <AdminLicenseKeysPage />,
      },
      {
        loader: adminSalesOrdersPageLoader,
        path: 'sales-orders',
        element: <AdminSalesOrdersPage />,
      },
      {
        loader: adminTemporaryAccessManagementPageLoader,
        path: 'temporary-access',
        element: <AdminTemporaryAccessManagementPage />,
      },
      {
        path: 'temporary-access/setup',
        element: <AdminTemporaryAccessSetupPage />,
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="/admin/temporary-access/setup/sales-orders"
                replace
              />
            ),
          },
          {
            loader: adminTemporaryAccessSalesOrdersPage,
            path: 'sales-orders',
            element: <AdminTemporaryAccessSalesOrdersPage />,
          },
          {
            path: 'user',
            element: <AdminTemporaryAccessUserPage />,
          },
        ],
      },
      {
        path: 'customer-access/setup',
        element: <AdminCustomerAccessSetupPage />,
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="/admin/customer-access/setup/sales-orders"
                replace
              />
            ),
          },
          {
            loader: adminTemporaryAccessSalesOrdersPage,
            path: 'sales-orders',
            element: <AdminCustomerAccessSalesOrdersPage />,
          },
          {
            path: 'user',
            element: <AdminCustomerAccessUserDetailsPage />,
          },
        ],
      },
    ],
  },
];
